import React from 'react';
/* Styles */
import './optionCounter.css';

const OptionCounter = ({ label, counter, increaseCounter, decreaseCounter }) => {
  return (
    <div className="option">
      <div className='option-label'>{label}</div>
      <div className='option-counter'>
        <div className='decrease' onClick={decreaseCounter}>-</div>
        <span>{counter}</span>
        <div className='increase' onClick={increaseCounter}>+</div>
      </div>
    </div>
  );
}

export default OptionCounter;
